// src/loop.ts -- touches rAF and performance.now, so NOT in sim/
import type { GameState } from './sim/state';
import { stepSim } from './sim/state';

const STEP = 1 / 60; // 16.666 ms physics tick
const MAX_FRAME = 0.25; // clamp to avoid spiral-of-death after tab resume
const MAX_STEPS_PER_FRAME = 5; // hard cap on catch-up steps

export function startLoop(
  getState: () => GameState,
  render: (state: GameState, alpha: number) => void,
  shouldStep: () => boolean = () => true,
) {
  let lastTime = performance.now() / 1000;
  let accumulator = 0;

  function frame(nowMs: number) {
    requestAnimationFrame(frame);
    const now = nowMs / 1000;
    let frameTime = now - lastTime;
    if (frameTime > MAX_FRAME) frameTime = MAX_FRAME;
    lastTime = now;

    const state = getState();
    if (shouldStep()) {
      accumulator += frameTime;
      let steps = 0;
      while (accumulator >= STEP && steps < MAX_STEPS_PER_FRAME) {
        stepSim(state, STEP);
        accumulator -= STEP;
        steps++;
      }
    } else {
      accumulator = 0; // don't build up while paused
    }
    const alpha = accumulator / STEP; // 0..1 for render interpolation
    render(state, alpha);
  }
  requestAnimationFrame(frame);
}
